import styled from '@emotion/styled';

type CellTextInputProps = {
  value: string | number;
  placeholder?: string;
  type?: 'text' | 'number';
  onChange: (value: string) => void;
};

export const CellInput = ({
  value,
  placeholder = '',
  type = 'text',
  onChange,
}: CellTextInputProps) => {
  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    event.stopPropagation();
    if (((event.ctrlKey || event.metaKey) && event.key === 's') || event.key === 'Enter') {
      event.preventDefault();
      onChange((event.target as HTMLInputElement).value);
    }
  };

  const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <Input
      defaultValue={value}
      onBlur={onBlur}
      type={type}
      placeholder={placeholder}
      onKeyDown={onKeyDown}
      autoFocus
    />
  );
};

const Input = styled.input`
  width: 100%;
  :focus-visible {
    outline: none;
  }
`;
